import { render, staticRenderFns } from "./FundManagerList.vue?vue&type=template&id=5f7b4ef8&scoped=true&"
import script from "./FundManagerList.vue?vue&type=script&lang=js&"
export * from "./FundManagerList.vue?vue&type=script&lang=js&"
import style0 from "./FundManagerList.vue?vue&type=style&index=0&id=5f7b4ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b4ef8",
  null
  
)

export default component.exports